// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../../state/criteria';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

function handleCriteriaInputChange(criteria, event) {

    this.onCriteriaInputChange(criteria, event);

}

const CriteriaSectionOne = props =>
    <div className='criteria-section-one'>
        <LabeledCriteria
            className='pin-criteria'
            isRequired={false}
            label='PIN'
            maxLength={17}
            onInputChange={handleCriteriaInputChange.bind(props, 'pin')}
            placeholder='PIN'
            type='text'
            value={props.criteria.pin}
        />
        <LabeledCriteria
            className='work-order-criteria'
            isRequired={false}
            label='WORK_ORDER_ONE'
            maxLength={17}
            onInputChange={handleCriteriaInputChange.bind(props, 'workOrderOne')}
            placeholder='WORK_ORDER_ONE'
            type='text'
            value={props.criteria.workOrderOne}
        />
    </div>;

CriteriaSectionOne.displayName = 'CriteriaSectionOne';
CriteriaSectionOne.propTypes = {
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    onCriteriaInputChange: PropTypes.func.isRequired
};

export default CriteriaSectionOne;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/components/report-criteria/criteria-section-one.js